import { ReportApi, CapabilityApi } from 'api/index';
import { getApiActionCreator } from 'helpers/actionHelper';
import { NEWCAPABILITIES, apiCallStatus } from 'helpers/constants';
import { actionTypes } from './constants';
import UserCapabilityHelper from 'helpers/userCapabilityHelper';
import { getPreselectedDates } from './helpers';

const getReportsAction = getApiActionCreator(actionTypes.GET_REPORTS);
const getReportCapabilitiesAction = getApiActionCreator(actionTypes.GET_REPORT_CAPABILITIES);

export const loadReports = () => {
    return (dispatch, getState) => {
        const organizations = getState().generalFilter.selectedFilters.organizations;
        const capabilities = getState().overview?.userCapabilities;
        const userCapabilities = new UserCapabilityHelper(capabilities);
        dispatch(getReportsAction(apiCallStatus.LOADING));
        return ReportApi.getReports(organizations, userCapabilities.hasExpertReportUpload())
            .then((reports) => {
                dispatch(getReportsAction(apiCallStatus.SUCCESS, reports));
            }, (err) => {
                dispatch(getReportsAction(apiCallStatus.ERROR, [], err));
            });
    };
};

export const refreshDateFilters = () => {
    return (dispatch) => {
        // Get fresh date ranges with current time
        const newPreselectedDates = getPreselectedDates();

        dispatch({
            type: actionTypes.SET_FILTERS,
            filters: {
                dateFilter: newPreselectedDates,
                reportingPeriodFilter: newPreselectedDates
            }
        });
    };
};

export const loadReportCapabilities = (assets) => {
    return (dispatch, getState) => {
        const organizationId = getState().generalFilter.selectedFilters.organizations[0].organizationID;
        const assetIds = assets.map((asset) => asset.id);
        const capabilityCodes = [
            NEWCAPABILITIES.assetInstantReport,
            NEWCAPABILITIES.expertReportUpload,
            NEWCAPABILITIES.regularReportUpload,
            NEWCAPABILITIES.deleteReport,
            NEWCAPABILITIES.fleetOverviewReportDelete,
            NEWCAPABILITIES.fleetDetailedReport
        ];
        return CapabilityApi.getCapabilities(organizationId, assetIds, capabilityCodes)
            .then((capabilities) => {
                dispatch(getReportCapabilitiesAction(apiCallStatus.SUCCESS, capabilities));
            }, (err) => {
                dispatch(getReportCapabilitiesAction(apiCallStatus.ERROR, [], err));
            });
    };
};
